
namespace RioERP.Masters {

    @Serenity.Decorators.registerClass()
    export class AllowedDevicesDialog extends Serenity.EntityDialog<AllowedDevicesRow, any> {
        protected getFormKey() { return AllowedDevicesForm.formKey; }
        protected getIdProperty() { return AllowedDevicesRow.idProperty; }
        protected getLocalTextPrefix() { return AllowedDevicesRow.localTextPrefix; }
        protected getNameProperty() { return AllowedDevicesRow.nameProperty; }
        protected getService() { return AllowedDevicesService.baseUrl; }
        protected getDeletePermission() { return AllowedDevicesRow.deletePermission; }
        protected getInsertPermission() { return AllowedDevicesRow.insertPermission; }
        protected getUpdatePermission() { return AllowedDevicesRow.updatePermission; }

        protected form = new AllowedDevicesForm(this.idPrefix);

    }
}